export class FileSyncModel {
    public id: number;
    public fileSystemTypeId: number;
    public content: string;
    public type: string;
    public name: string;
    public sizeInBytes: number;
    public updatedOn: string;
}